import React, { Component } from 'react';
import { Icon, message, Modal, Input, Button, Row, Tooltip, Dropdown, Menu } from "antd";
import { inject, observer } from "mobx-react";
import './index.scss';
import moment from "moment";
import SelectHotel from "../../bp-views/app/SelectHotel";
import HrUser from "@/hr/user";
import BpUser from "@/bp-views/user";

import VIP from "../../assets/VIP.png";
import noVIP from "../../assets/VIP 2.png";

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            visible: false,
            data: {
                password: "",
                comfirm: ""
            },
            loadingSave: false
        }
    }

    componentDidMount() {
        this.props.store.menu.getUserInfo().then(user => {
            this.setState({ user });
        }).catch(err => {
            console.error(err)
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false,
            data: {
                password: "",
                comfirm: ""
            }
        });
    }

    handleOk = () => {
        let data = this.state.data;
        this.setState({ loadingSave: true });
        if (!data.password || !data.confirm || data.password != data.confirm) {
            message.error('输入错误，请检查密码！');
            this.setState({ loadingSave: false });
            return
        }

        let dataFrom = new FormData();
        delete data.confirm;
        let user = this.state.user;

        data = {
            id: user.id,
            password: data.password
        };
        // console.log(data);
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataFrom.append(key, data[key]);
            }
        }

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addUser', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('修改成功！，请重新登录');
                var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
                if (keys) {
                    for (var i = keys.length; i--;)
                        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
                };
                sessionStorage.clear();
                window.location.href = '/#/login'
                return
            }
            this.setState({
                loadingSave: false
            });

        }).catch(err => {
            console.error(err);
            message.error('数据添加失败！')
            this.setState({
                loadingSave: false
            });
        })
    }

    onPush = (path) => {
        this.props.history.push(path);
    }

    render() {
        const { user } = this.state;
        const hotel = user.hotel || {};
        const { display, onChangeDisplay } = this.props.store.menu;
        const isVip = new Date(hotel.expire_date || "2019-06-01").valueOf() > new Date().valueOf()

        return (
            <div className={`user  `}>
                <div className='app-icon'>
                    <Tooltip title="菜单">
                        <Icon type="menu-unfold" theme="outlined" onClick={() => {
                            onChangeDisplay('none');
                        }} />
                    </Tooltip>
                    {(user.email || "").includes('admin') && !display ? < SelectHotel user={user} display={display} /> : null}

                </div>
                {[55, 38].includes(hotel.id) && <div className="prompt">
                    *该酒店2024年度经营预算为业主方预算
                </div>}
                <div className="user-name">
                    <div className="expire_date" onClick={this.onPush.bind(this, '/table/personal')}>
                        <Tooltip title={isVip ? '专业用户' : '普通用户'}>
                            <img src={isVip ? VIP : noVIP} alt="" />
                        </Tooltip>
                        <span>{moment(hotel.expire_date || "2019-07-01").format('YYYY-MM-DD')}</span>
                        {/* <span onClick={this.onPush.bind(this, '/pay')}>
                            {isVip ? '续费' : '升级'}
                        </span> */}
                    </div>

                    <Dropdown overlay={(
                        <Menu>
                            <Menu.Item
                            >
                                <div className="user_expire_text">
                                    <span>系统到期时间</span>
                                    <span onClick={this.onPush.bind(this, '/pay')}>
                                        {isVip ? '续费' : '升级'}
                                    </span>
                                </div>
                                {isVip && <div className="user_expire_date">
                                    {moment(hotel.expire_date || "2019-07-01").format('YYYY-MM-DD')}
                                </div>}
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item
                                onClick={() => {
                                    this.onPush('/table/personal');
                                }}
                            >
                                <Icon type="database" />
                                账户信息
                            </Menu.Item>
                            {this.props.user == 'hr' && <Menu.Item  >
                                <HrUser />
                            </Menu.Item>}
                            {this.props.user == 'bp' && <Menu.Item  >
                                <BpUser />
                            </Menu.Item>}
                            {
                                !this.props.user && <Menu.Item
                                    onClick={() => {
                                        if (this.state.user.email === 'admin') {
                                            this.onPush('/table/setting');
                                            return
                                        }
                                        this.setState({ visible: true });
                                    }}
                                >
                                    <Icon type="setting" />
                                    {this.state.user.email === 'admin' ? '设置' : '修改密码'}
                                </Menu.Item>
                            }

                            <Menu.Item
                                onClick={() => {
                                    this.props.store.menu.onLogout(this.props);
                                }}
                            >
                                <Icon type="logout" />
                                退出
                            </Menu.Item>
                        </Menu>
                    )}>
                        <div>{user.name || ""}  <Icon type="caret-up" /></div>
                    </Dropdown>

                </div>
                <Modal
                    title='修改密码'
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row className="settings-modal-content" >
                        <span>密码：</span>
                        <Input
                            placeholder="请输入密码"
                            style={{ width: '60%', marginLeft: 38 }}
                            value={this.state.data.password}
                            type='password'
                            name="ppp"
                            onChange={(e) => {
                                let value = e.target.value;
                                let data = this.state.data;
                                data.password = value;
                                this.setState({
                                    data
                                });
                            }}
                        />
                    </Row>
                    <Row className="settings-modal-content" >
                        <span>确认：</span>
                        <Input
                            placeholder="请输入密码"
                            style={{ width: '60%', marginLeft: 38 }}
                            value={this.state.data.confirm}
                            type='password'
                            name="ppp"
                            onChange={(e) => {
                                let value = e.target.value;
                                let data = this.state.data;
                                data.confirm = value;
                                this.setState({
                                    data
                                });
                            }}
                        />
                    </Row>
                    <Row className="settings-modal-content" style={{ color: "red", paddingLeft: 80 }}>
                        {this.state.data.password && this.state.data.confirm && this.state.data.password != this.state.data.confirm ? '两次输入的密码不一致！' : ""}
                    </Row>
                </Modal>
            </div >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/user/index.js